import { useQuery } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'
import { genericApi } from '~/api'
import { setUser } from '~/store/auth/slice'
import { showErrors } from '~/utils/helpers'

export const useProfileQuery = (token) => {
  const dispatch = useDispatch()
  return useQuery({
    queryKey: ['profile', token],
    queryFn: async () => {
      const { data } = await genericApi.getProfile()
      return data.data
    },
    enabled: token != null,
    retry: false,
    refetchOnWindowFocus: false,
    onSuccess: (data) => dispatch(setUser(data)),
    onError: showErrors
  })
}
